import { render, staticRenderFns } from "./AllTab.vue?vue&type=template&id=3a6c140f&scoped=true"
import script from "./AllTab.vue?vue&type=script&lang=js"
export * from "./AllTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c140f",
  null
  
)

export default component.exports